import { createSvgIcon } from '@mui/material';

const BillingListIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M9.33335 7.33337H5.33335M6.66669 10H5.33335M10.6667 4.66671H5.33335M13.3334 4.53337V11.4667C13.3334 12.5868 13.3334 13.1469 13.1154 13.5747C12.9236 13.951 12.6177 14.257 12.2413 14.4487C11.8135 14.6667 11.2535 14.6667 10.1334 14.6667H5.86669C4.74658 14.6667 4.18653 14.6667 3.75871 14.4487C3.38238 14.257 3.07642 13.951 2.88467 13.5747C2.66669 13.1469 2.66669 12.5868 2.66669 11.4667V4.53337C2.66669 3.41327 2.66669 2.85322 2.88467 2.42539C3.07642 2.04907 3.38238 1.74311 3.75871 1.55136C4.18653 1.33337 4.74658 1.33337 5.86669 1.33337H10.1334C11.2535 1.33337 11.8135 1.33337 12.2413 1.55136C12.6177 1.74311 12.9236 2.04907 13.1154 2.42539C13.3334 2.85322 13.3334 3.41327 13.3334 4.53337Z"
            // stroke="#344054"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'BillingList'
);

export default BillingListIcon;
